/* Source: /home/runner/work/jaseci-blogs/jaseci-blogs/pages/index.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useNavigate } from "@jac/runtime";
import { useEffect } from "@jac/runtime";
function Page() {
  let nav = useNavigate();
  useEffect(() => {
    nav("/blog", {"replace": true});
  }, []);
  return __jacJsx("section", {"className": "container narrow", "style": {"padding": "4rem 0"}}, [__jacJsx("p", {"className": "muted"}, ["Redirecting…"])]);
}
const page = Page;
/*jac:refresh-boundary*/;
export {page};
//# sourceMappingURL=index.js.map
